import { PdFooter } from "./pd-footer/PdFooter.js";
//#region src/pd-footer/pd-footer.ts
var tag = "pd-footer";
if (!customElements.get(tag)) customElements.define(tag, PdFooter);
//#endregion
export { PdFooter };
